<template>
  <div class="skeleton-container">
    <router-link to="/userCenter" class="back-link">
      <img src="@/assets/images/arrow_left.svg" alt="Back" class="back_btn" />
    </router-link>
    <div class="resume_detail">
      <div class="skeleton-title"></div>
      <div class="skeleton-description"></div>

      <div class="skeleton-score-wrapper">
        <div class="skeleton-label"></div>
        <div class="skeleton-tips"></div>
        <div class="skeleton-btns">
          <div class="skeleton-btn" v-for="i in 5" :key="i"></div>
        </div>
      </div>

      <div class="info-wrapper">
        <div class="info">
          <div class="skeleton-name"></div>
          <div class="skeleton-type"></div>
          <div class="skeleton-contact">
            <div class="skeleton-email"></div>
            <div class="skeleton-phone"></div>
          </div>
        </div>
        <div class="skeleton-avatar"></div>
      </div>

      <div class="tag-wrapper">
        <div class="skeleton-tag" v-for="i in 4" :key="i"></div>
      </div>

      <div class="video-wrapper">
        <div class="skeleton-video-title"></div>
        <div class="skeleton-video-content">
          <div class="skeleton-video" v-for="i in 2" :key="i"></div>
        </div>
      </div>

      <div class="advantage-wrapper">
        <div class="skeleton-section-title"></div>
        <div class="skeleton-description-content"></div>
      </div>

      <div class="work-wrapper">
        <div class="skeleton-section-title"></div>
        <div class="skeleton-experience">
          <div class="skeleton-company"></div>
          <div class="skeleton-position"></div>
          <div class="skeleton-time"></div>
          <div class="skeleton-content"></div>
        </div>
      </div>

      <div class="education-wrapper">
        <div class="skeleton-section-title"></div>
        <div class="skeleton-experience">
          <div class="skeleton-school"></div>
          <div class="skeleton-degree"></div>
          <div class="skeleton-content"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup></script>

<style scoped>
.skeleton-container {
  width: 100%;
  padding: 20px 0;
  position: relative;
}

.back-link {
  position: fixed;
  top: 32px;
  left: 32px;
  z-index: 100;
}

.back_btn {
  width: 24px;
  height: 24px;
  cursor: pointer;
}

.resume_detail {
  max-width: 670px;
  margin: 0 auto;
  background: #ffffff;
  border-radius: 28px;
  padding: 40px 0;
}

.skeleton-title {
  width: 160px;
  height: 32px;
  background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
  background-size: 200% 100%;
  animation: shimmer 1.5s infinite;
  margin: 0 auto 8px;
  border-radius: 4px;
}

.skeleton-description {
  width: 300px;
  height: 16px;
  background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
  background-size: 200% 100%;
  animation: shimmer 1.5s infinite;
  margin: 0 auto 30px;
  border-radius: 4px;
}

.skeleton-score-wrapper {
  padding: 0 23px 20px;
}

.skeleton-label {
  width: 220px;
  height: 18px;
  background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
  background-size: 200% 100%;
  animation: shimmer 1.5s infinite;
  margin-bottom: 8px;
  border-radius: 4px;
}

.skeleton-tips {
  width: 280px;
  height: 16px;
  background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
  background-size: 200% 100%;
  animation: shimmer 1.5s infinite;
  margin-bottom: 16px;
  border-radius: 4px;
}

.skeleton-btns {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
}

.skeleton-btn {
  width: 180px;
  height: 36px;
  background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
  background-size: 200% 100%;
  animation: shimmer 1.5s infinite;
  border-radius: 20px;
}

.info-wrapper {
  padding: 0 23px;
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 24px;
}

.info {
  flex: 1;
}

.skeleton-name {
  width: 140px;
  height: 28px;
  background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
  background-size: 200% 100%;
  animation: shimmer 1.5s infinite;
  margin-bottom: 12px;
  border-radius: 4px;
}

.skeleton-type {
  width: 200px;
  height: 18px;
  background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
  background-size: 200% 100%;
  animation: shimmer 1.5s infinite;
  margin-bottom: 16px;
  border-radius: 4px;
}

.skeleton-contact {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.skeleton-email,
.skeleton-phone {
  width: 180px;
  height: 18px;
  background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
  background-size: 200% 100%;
  animation: shimmer 1.5s infinite;
  border-radius: 4px;
}

.skeleton-avatar {
  width: 100px;
  height: 100px;
  background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
  background-size: 200% 100%;
  animation: shimmer 1.5s infinite;
  border-radius: 50%;
}

.tag-wrapper {
  padding: 0 23px;
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  margin-bottom: 24px;
}

.skeleton-tag {
  width: 80px;
  height: 32px;
  background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
  background-size: 200% 100%;
  animation: shimmer 1.5s infinite;
  border-radius: 20px;
}

.video-wrapper,
.advantage-wrapper,
.work-wrapper,
.education-wrapper {
  padding: 0 23px;
  margin-bottom: 32px;
}

.skeleton-video-title,
.skeleton-section-title {
  width: 120px;
  height: 24px;
  background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
  background-size: 200% 100%;
  animation: shimmer 1.5s infinite;
  margin-bottom: 16px;
  border-radius: 4px;
}

.skeleton-video-content {
  display: flex;
  gap: 16px;
}

.skeleton-video {
  flex: 1;
  height: 160px;
  background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
  background-size: 200% 100%;
  animation: shimmer 1.5s infinite;
  border-radius: 8px;
}

.skeleton-description-content {
  width: 100%;
  height: 80px;
  background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
  background-size: 200% 100%;
  animation: shimmer 1.5s infinite;
  border-radius: 4px;
}

.skeleton-experience {
  width: 100%;
}

.skeleton-company,
.skeleton-school {
  width: 160px;
  height: 22px;
  background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
  background-size: 200% 100%;
  animation: shimmer 1.5s infinite;
  margin-bottom: 8px;
  border-radius: 4px;
}

.skeleton-position,
.skeleton-degree {
  width: 140px;
  height: 18px;
  background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
  background-size: 200% 100%;
  animation: shimmer 1.5s infinite;
  margin-bottom: 8px;
  border-radius: 4px;
}

.skeleton-time {
  width: 120px;
  height: 16px;
  background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
  background-size: 200% 100%;
  animation: shimmer 1.5s infinite;
  margin-bottom: 12px;
  border-radius: 4px;
}

.skeleton-content {
  width: 100%;
  height: 60px;
  background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
  background-size: 200% 100%;
  animation: shimmer 1.5s infinite;
  border-radius: 4px;
}

@keyframes shimmer {
  0% {
    background-position: 200% 0;
  }
  100% {
    background-position: -200% 0;
  }
}
</style>
